import React, { Fragment } from 'react';
import "./App.scss";
import Routes from './routes';
 
const App = () => (
  <Fragment>
    <Routes />
  </Fragment>
)
 
export default App;
